import { motion } from 'framer-motion'
import { OurValue } from './data/section3Data'
import { useIsInView } from 'hooks/useIsInView'

const titleVariants = {
  initial: {
    fontSize: '18px',
  },
  enlarged: {
    fontSize: '32px',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
}

const bodyVariants = {
  initial: {
    fontSize: '12px',
  },
  enlarged: {
    fontSize: '18px',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
}

interface OurValuesItemDesktopProps extends OurValue {
  index: number // used to stagger the animation for each item (if needed)
}

export const OurValuesItemDesktop = ({
  index,
  bgColor,
  title,
  titleTextColor,
  description,
}: OurValuesItemDesktopProps) => {
  const elementId = `dt-item-${index}`
  const isInView = useIsInView(elementId)

  return (
    <>
      <motion.div
        initial={{ width: '300px', height: '380px', marginLeft: '40px' }}
        animate={
          isInView
            ? { width: '33.33vw', height: '600px', marginLeft: '0' }
            : {}
        }
        transition={{ duration: 0.5 }}
      >
        <div id={elementId}
          className={`flex flex-col items-center justify-center text-center p-10 gap-40 ${bgColor}`}
          style={{ height: 'inherit' }}
        >
          <motion.h3 variants={titleVariants} animate={isInView ? 'enlarged' : {}} initial='initial'
            className={`font-bold leading-6 tracking-[0.4px] ${titleTextColor}`}>
            {title}
          </motion.h3>
          <motion.p variants={bodyVariants} animate={isInView ? 'enlarged' : {}} initial='initial'
            className='font-normal text-[#37455C] w-48'
            style={{ width: '220px' }}>
            {description}
          </motion.p>
        </div>
      </motion.div >
    </>
  )
}
